module.exports = __webpack_public_path__ + "static/media/Color_Game.ee88c7a2.png";